/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { useState, useEffect } from "react";

import { Link } from "react-router-dom";

// reactstrap components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Navbar,
  Nav,
  Container,
  Media,
} from "reactstrap";
import {api} from '../../../../api'
import Cookies from 'js-cookie';

const AdminNavbar = (props) => {
  const [isAlertDropdownOpen, setIsAlertDropdownOpen] = useState(false);
  const [isNotification, setIsNotification] = useState(false);
  const [notificationCount, setNotificationCount] = useState(10);

  const toggleAlertDropdown = () => {
    setIsAlertDropdownOpen(!isAlertDropdownOpen);
  };

  const [tasks, setTasks] = useState({
    pm_name : '',
    profile_image: ''
  });

  const cookieId = Cookies.get('token');
  const company_id = Cookies.get('company_id');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const emp_id = Cookies.get('emp_id');
        if (!company_id || !emp_id) {
          throw new Error('Missing company_id or emp_id in cookies');
        }
        const response = await api.get(`PMprofileView.php?company_id=${company_id}&emp_id=${emp_id}`);
        setTasks({
          pm_name: response.data.emp_name,
          profile_image : response.data.profile_image
        })
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const [task,setTask] = useState([]);
  const [projectNoti, setprojectNoti] = useState([]);
  
  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const emp_id = Cookies.get('emp_id');
        if (!company_id || !emp_id) {
          throw new Error('Missing company_id or emp_id in cookies');
        }
        const response = await api.get(`notificationTasks.php?id=${emp_id}&company_id=${company_id}`);
        setTask(response.data);
        console.log(response.data);
      } catch (error) {
        console.error('Error fetching tasks:', error);
      }
    };

    const fetchProjectNoti = async () => {
      try {
        if (!company_id) {
          throw new Error('Missing company_id in cookies');
        }
        const response2 = await api.get(`projectNotification.php?gm_id=${cookieId}&company_id=${company_id}`);
        setprojectNoti(response2.data);
        console.log(response2.data);
      } catch (error) {
        console.error('Error fetching project notifications:', error);
      }
    };

    fetchTasks();
    fetchProjectNoti();
  }, [cookieId]);

  console.log(projectNoti.length);

  useEffect(() => {
    setNotificationCount((projectNoti.length === "undefined" ? 0 : projectNoti.length));
  }, [task, projectNoti]);

  const handleTaskClick = async (taskId) => {
    try {
      await api.post(`updateNotificationStatus.php?company_id=${company_id}`, { t_id: taskId });
      setTask((prevTasks) => prevTasks.filter((task) => task.t_id !== taskId));
    } catch (error) {
      console.error("Error updating notification status:", error);
    }
  };

  const handleLogout = async () => {
    try {
      const response = await api.get(`logout.php?emp_id=${cookieId}&company_id=${company_id}`);
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'path=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'role=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/login';
  };

  const handleProjectStatusClick = async (noti_Id) => {
    try {
      await api.post("projectNotification.php", { gm_id : cookieId, n_id: noti_Id, company_id });
      setprojectNoti((prevTasks) => prevTasks.filter((projectNoti) => projectNoti.n_id !== noti_Id));
    } catch (error) {
      console.error("Error updating notification status:", error);
    }
  };

  return (
    <>
      <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
        <Container fluid>
          <Link
            className="h4 mb-0 text-black text-uppercase d-none d-lg-inline-block"
            to="/general-admin/general-management/Index"
          >
            {props.brandText}
          </Link>
          <Nav className="align-items-center d-none d-md-flex" navbar>
          <UncontrolledDropdown nav inNavbar isOpen={isAlertDropdownOpen} toggle={toggleAlertDropdown} style={{zIndex: '10'}}>
              <DropdownToggle nav className="nav-link-icon fa-stack mb-2">
                <i className={isNotification ? "fa-solid fa-bell fa-bounce" : "fa-solid fa-bell"}style={{zIndex:'1' ,position:'relative',color:'black'}} />
                {notificationCount > 0 && (
                  <span className="badge badge-danger" style={{ position: 'absolute', right: '-4px', top: '1px', fontSize:'9px', borderRadius:'50%', zIndex:'0'}}>
                    {notificationCount}
                  </span>
                )}
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem>Notification</DropdownItem>
                <DropdownItem divider />
                {Array.isArray(task) && task.length > 0 && (
                  task.map(task => (
                    <DropdownItem key={task.t_id} onClick={() => handleTaskClick(task.t_id)} style={{ padding: '15px', borderBottom: '1px solid #f0f0f0' }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img
                          alt="Profile"
                          src={window.location.hostname === 'localhost'
                              ? require(`../../../images/${task.profile_image}`)
                              : `/images/${task.profile_image}`}
                          style={{ width: '50px', height: '50px', borderRadius: '50%', marginRight: '20px' }}
                        />
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>Assigned By: {task.emp_name}</div>
                          <div style={{ marginBottom: '5px', color: '#333' }}>Task Name: {task.taskname}</div>
                          <div style={{ color: '#777' }}>End Date: {task.end_date}</div>
                        </div>
                      </div>
                    </DropdownItem>
                  ))
                )}

                {Array.isArray(projectNoti) && projectNoti.length > 0 && (
                  projectNoti.map(noti => (
                    <DropdownItem key={noti.n_id} onClick={() => handleProjectStatusClick(noti.n_id)} style={{ padding: '15px', borderBottom: '1px solid #f0f0f0' }}>
                      <div style={{ display: 'flex', alignItems: 'center', border: 'none' }}>
                        <img
                          alt="Profile"
                          src={window.location.hostname === 'localhost'
                              ? require(`../../../images/${noti.profile_image}`)
                              : `/images/${noti.profile_image}`}
                          style={{ width: '50px', height: '50px', borderRadius: '50%', marginRight: '20px' }}
                        />
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>Name : {noti.emp_name}</div>
                          <div style={{ marginBottom: '5px', color: '#333' }}>New project[{noti.message}] has been {noti.status}.</div>
                        </div>
                      </div>
                    </DropdownItem>
                  ))
                )}

                {(!Array.isArray(task) || task.length === 0) && 
                (!Array.isArray(projectNoti) || projectNoti.length === 0) && (
                  <DropdownItem>
                  No notifications
                  </DropdownItem>
                )}
              </DropdownMenu>
            </UncontrolledDropdown>

          
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav>
              <Media className="align-items-center">
                  <Media className="mr-3 d-none d-lg-block">
                    <span className="mb-0 text-sm font-weight-bold" style={{color:'black'}}>
                     
                      Hello, {tasks.pm_name}!
                    </span>
                  </Media>
                  <span className="avatar avatar-sm rounded-circle">
                    {tasks.profile_image && 
                      <img
                      style={{
                        width: '50px',
                        height: '40px',
                      }}
                        alt="Profile"
                        src={window.location.hostname === 'localhost' 
                            ? require(`../../../images/${tasks.profile_image}`)
                            : `/images/${tasks.profile_image}`}
                        onError={e => { e.target.onerror = null; e.target.src = '/images/default-profile.png'; }}
                      />
                    }
                  </span>
                  
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome!</h6>
                </DropdownItem>
                <DropdownItem to="/general-admin/general-management/Profile1" tag={Link}>
                  <i className="ni ni-single-02" />
                  <span>My profile</span>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={() => handleLogout()}>
                <i className="ni ni-user-run" />
                <span>Logout</span>
              </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Container>
      </Navbar>
    </>
  );
};

export default AdminNavbar;
